import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { IssueEntity } from './issue.entity';
import { PublicUserEntity } from './public-user.entity';

@Index('issue_note_ibfk_1', ['fkIssueId'], {})
@Entity('issue_note')
export class IssueNoteEntity extends BaseEntity {
	@Column('int', { name: 'fk_issue__id', unsigned: true })
	public fkIssueId!: number;

	// Plain text. With rich text (PD-16475) this is the copy derived from
	// `noteHtml`, kept so everything that reads note text as text (the
	// legacy CRM, emails, search, AI tools) is unchanged.
	@Column('longtext', { name: 'note' })
	public note!: string;

	// PD-16475 — the note's sanitized rich text (see
	// `sanitizeIssueRichText`). NULL for notes written before rich text or
	// through a plain-text path; those display `note`.
	@Column('longtext', { name: 'noteHtml', nullable: true })
	public noteHtml!: string | null;

	@Column('tinyint', { name: 'is_pinned', width: 1, default: 0 })
	public isPinned!: boolean;

	// PD-13773 — customer↔support communication thread on portal-submitted
	// issues. Set only when the note was written by a portal (public) user
	// replying from the storefront; NULL for CRM-authored notes.
	@Column('int', {
		name: 'fk_public_user__id_author',
		nullable: true,
		unsigned: true,
	})
	public authorPublicUserId!: number | null;

	@ManyToOne(() => PublicUserEntity, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([
		{ name: 'fk_public_user__id_author', referencedColumnName: 'id' },
	])
	public authorPublicUser!: PublicUserEntity | null;

	// PD-13773 — whether the customer can see this note in the portal thread.
	// Defaults FALSE so existing/staff notes stay internal unless a staff
	// member explicitly shares one; customer-authored notes are always saved
	// with TRUE.
	@Column('tinyint', { name: 'isPortalVisible', width: 1, default: 0 })
	public isPortalVisible!: boolean;

	@ManyToOne(() => IssueEntity, (issue) => issue.issueNotes, {
		onDelete: 'CASCADE',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_issue__id', referencedColumnName: 'id' }])
	public fkIssue!: IssueEntity;
}
